import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Sparkles, X } from "lucide-react";

// ISO week key like "2026-W38" so the banner shows at most once per week.
function weekKey() {
  const d = new Date();
  const onejan = new Date(d.getFullYear(), 0, 1);
  const week = Math.ceil((((d - onejan) / 86400000) + onejan.getDay() + 1) / 7);
  return `${d.getFullYear()}-W${week}`;
}

export default function ChatRecapBanner() {
  const [recap, setRecap] = useState(null);
  const key = weekKey();

  useEffect(() => {
    if (localStorage.getItem("zaf_recap_seen") === key) return;
    (async () => {
      try {
        const { data } = await api.get("/wellbeing/recap");
        const s = data?.stats || {};
        if (data?.summary && ((s.checkins || 0) + (s.messages || 0)) > 0) setRecap(data);
      } catch (e) {
        /* silent */
      }
    })();
  }, [key]);

  const dismiss = () => {
    localStorage.setItem("zaf_recap_seen", key);
    setRecap(null);
  };

  if (!recap) return null;

  return (
    <div
      data-testid="chat-recap-banner"
      className="relative rounded-3xl border border-[#2E9D96]/25 bg-gradient-to-br from-white to-[#EAF5F3] p-5 shadow-sm"
    >
      <button
        onClick={dismiss}
        data-testid="chat-recap-dismiss"
        className="absolute top-3.5 right-3.5 text-slate-400 hover:text-slate-700 transition-colors"
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
      <div className="flex items-center gap-2 text-[#1F7B75]">
        <Sparkles size={16} />
        <span className="text-xs uppercase tracking-[0.2em] font-semibold">Your week with Zaf</span>
      </div>
      <p className="mt-2.5 text-[15px] leading-relaxed text-slate-700">{recap.summary}</p>
      <Link
        to="/profile"
        data-testid="chat-recap-viewfull"
        className="inline-block mt-3 text-sm font-semibold text-[#2E9D96] hover:text-[#1F7B75] transition-colors"
      >
        See your full week →
      </Link>
    </div>
  );
}
